var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.71875C3.54286 0.71875 0 4.26161 0 8.71875C0 13.1759 3.54286 16.7188 8 16.7188C12.4571 16.7188 16 13.1759 16 8.71875C16 4.26161 12.4571 0.71875 8 0.71875ZM11.0857 12.7188L8 9.63304L4.91429 12.7188L4 11.8045L7.08571 8.71875L4 5.63304L4.91429 4.71875L8 7.80446L11.0857 4.71875L12 5.63304L8.91429 8.71875L12 11.8045L11.0857 12.7188Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.7fd89f42233c811275c1c6cbf91c679b.svg";
export { ForwardRef as ReactComponent };